import { Inject, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, fromEvent, Subscription } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { ScreenSize } from '../models/screenSize';
import { WINDOW } from '@ag/vc.ag-core/tokens';

@Injectable({
  providedIn: 'root'
})
export class ScreenSizeService implements OnDestroy {
  private screenSizeSubject: BehaviorSubject<ScreenSize>;
  private screenSize: Observable<ScreenSize>;
  subscription: Subscription;

  constructor(
    // @Inject(Document) private readonly document: Document
    @Inject(WINDOW) private readonly window: Window
  ) {
    this.screenSizeSubject = new BehaviorSubject<ScreenSize>(this.getScreenSize());
    this.screenSize = (this.screenSizeSubject as Observable<ScreenSize>).pipe(distinctUntilChanged());

    this.subscription = fromEvent(this.window, 'resize')
      .pipe(
        map(this.getScreenSize)
      )
      .subscribe(event => {
        this.screenSizeSubject.next(event);
      });
  }

  public getScreenSize = (): ScreenSize => {
    if (this.window.innerWidth < 480) {
      return ScreenSize.x_small;
    } else if (this.window.innerWidth < 768) {
      return ScreenSize.small;
    } else if (this.window.innerWidth < 992) {
      return ScreenSize.medium;
    } else if (this.window.innerWidth < 1200) {
      return ScreenSize.large;
    } else {
      return ScreenSize.x_large;
    }
  }

  resize(): Observable<ScreenSize> {
    return this.screenSize;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
